<div class="sub-answer__label">
    <label class="sub-answer__labelText" [innerHtml]="subquestion.libelle"> </label>
</div>
<div class="sub-answer__input">
    <input [id]="subquestion.id + '-' + controlId" class="textfield textfield--full" [matDatepicker]="dp" [formControl]="myControl" [max]="maxDate" [min]="minDate" placeholder="MM/AAAA" />
    <mat-datepicker-toggle matSuffix [for]="dp"></mat-datepicker-toggle>
    <mat-datepicker color="primary" #dp startView="multi-year" (yearSelected)="chosenYearHandler($event)" (monthSelected)="chosenMonthHandler($event, dp)" panelClass="example-month-picker"> </mat-datepicker>
</div>
